import { useUpsertInventoryValueList } from "@/domain/inventory/hooks/api/use-upsert-inventory-value";
import { useCurrentInventoryContext } from "@/domain/inventory/hooks/use-current-inventory-context";
import { GhgQuality } from "@ark/shared";

const ENERGY_TYPE = "Energy";


export interface GhgInputQualityValues {
  gpcQualityRating: GhgQuality | null;
  referenceYear: number | null;
  dataSource: string | null;
}

export interface GhgInputCellContext {
  energySourceId: string;
  sectorId: string;
  subsectorId: string;
  subsubsectorId?: string | null;
  scope: number | null;
  amount: number;
  existingId?: string;
}

export const useGhgInputMutations = () => {
  const { currentInventory } = useCurrentInventoryContext();
  const { upsertInventoryValueList } = useUpsertInventoryValueList();

  const writeCellQuality = (context: GhgInputCellContext, values: GhgInputQualityValues) => {
    const shared = {
      amount: context.amount,
      gpcQualityRating: values.gpcQualityRating,
      referenceYear: values.referenceYear,
      dataSource: values.dataSource,
    };
    const input =
      context.existingId && !context.existingId.startsWith("temp-")
        ? { id: context.existingId, inventoryId: currentInventory.id, ...shared }
        : {
            inventoryId: currentInventory.id,
            energySourceId: context.energySourceId,
            sectorId: context.sectorId,
            subsectorId: context.subsectorId,
            subsubsectorId: context.subsubsectorId ?? undefined,
            scope: context.scope ?? undefined,
            type: ENERGY_TYPE,
            ...shared,
          };
    upsertInventoryValueList({ upsertInventoryValueInputList: [input] });
  };

  return { writeCellQuality };
};
